<template>
  <div v-if="improvement && getClaims">
    <div class="row">
      <div class="col-md-12 col-lg-8 mt-3">
        <portlet
            :icon="'fas fa-lightbulb-on portlet-icon'"
            :title="$t('improvements.improvement.improvement')"
            :actions-block="true"
            :fullheight="true"
            class="portlet-pt-20"
        >
          <template slot="actionsBlock">
            <button class="btn btn-secondary" @click="$router.go(-1)">
              <i class="fas fa-long-arrow-left mr-2"></i> Back
            </button>
            <router-link
                class="btn btn-primary mr-3"
                v-if="improvement.jobId"
                :to="{ path: '/start-stop/' + improvement.jobId }"
            >
              View Job
            </router-link>
            <LikeButton class="mr-5" :improvement="improvement"></LikeButton>
          </template>
          <template slot="portletBody">
            <div>
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <h4 v-if="getMe.id != improvement.userId">
                    {{ improvement.title }}
                  </h4>
                  <div v-else class="form-group">
                    <label for="title">{{
                        $t("improvements.improvement.title")
                      }}</label>
                    <input
                        type="text"
                        class="form-control"
                        v-validate="'required'"
                        name="title"
                        v-model="improvement.title"
                    />
                    <required-notice
                        v-if="errors.first('title')"
                        :notice="errors.first('title')"
                    />
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">

                  <label for="status">Status</label>
                  <select
                      @change="updateStatus()"
                      class="form-control mr-5"
                      name="status"
                      id="status"
                      v-model="improvement.status"
                      :disabled="
                      improvement.status === 'denied' && !getClaims.admin
                    "
                  >
                    <option
                        :key="idx + 1"
                        v-for="(status, idx) in statusses"
                        :value="status.value"
                        v-show="
                        status.visible ||
                        (getClaims.admin && status.rights == 'admin')
                      "
                    >
                      {{
                        $t(`improvements.improvement.statusses.${status.value}`)
                      }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4 col-sm-12   ">
                  <label for="assignee">{{ $t('improvements.improvement.assignedTo') }}</label>
                  <select
                      @change="updateAssignee($event)"
                      class="form-control mr-5"
                      name="assignee"
                      id="assignee"
                      v-model="improvement.assignedUser.uid"
                  >
                    <option
                        v-for="user in allUsers"
                        :key="user.index"
                        :value="user.uid"
                    >
                      {{ user.displayName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">

              </div>
              <div class="row">
                <div class="col-12">
                  <p>
                    <small
                    >{{ $t("improvements.improvement.createdBy") }}
                      {{
                        improvement.employeeName
                            ? `${improvement.userName} (${improvement.employeeName})`
                            : improvement.userName
                      }}
                      <br
                      /></small>
                    <small
                    >{{ $t("improvements.improvement.assignedTo") }}
                      {{
                        improvement.assignedUser
                            ? `${improvement.assignedUser.name}`
                            : improvement.assignedUser.name
                      }}
                      <br
                      /></small>
                    <small v-if="improvement.department">{{
                        improvement.department
                      }}</small>
                    <br/>
                    <small
                    >{{ $t("improvements.improvement.createdAt") }}
                      {{ formatDate(improvement.created_at) }}</small
                    ><br/>
                    <small v-if="improvement.updated_at"
                    >{{ $t("improvements.improvement.updatedAt") }}
                      {{ formatDate(improvement.updated_at) }}</small
                    >
                  </p>

                  <div v-if="getMe.id != improvement.userId">
                    <p style="white-space: pre-line"> {{ improvement.body }} </p>

                    <viewer :images="images" class="images clear-fix" :options="viewerOptions" v-if="images.length > 0">
                      <img v-for="image in images" class="preview-image  col" :key="image.imgSrc"
                           :src="image.imgSrc">

                    </viewer>
                  </div>

                  <div class="form-group" v-else>
                    <div class="row">
                      <div class="col-12">
                        <h5>{{ $t('improvements.improvement.attachedImages') }}</h5>
                      </div>
                    </div>

                    <div class="row">
                      <viewer :images="images" class="images clear-fix" :options="viewerOptions"
                              v-if="images.length > 0">
                        <img v-for="image in images" class="preview-image  col" :key="image.imgSrc"
                             :src="image.imgSrc">

                      </viewer>
                    </div>


                    <textarea
                        v-validate="'required|min:10'"
                        class="form-control mb-3"
                        name=""
                        id=""
                        cols="30"
                        rows="10"
                        v-model="improvement.body"
                    ></textarea>
                    <required-notice
                        v-if="errors.first('body')"
                        :notice="errors.first('body')"
                    />

                    <button class="btn btn-success" @click="saveChanges()">
                      {{ $t("ui.save") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </portlet>
      </div>

      <div class="col-md-12 col-lg-4 mt-3">
        <portlet
            :icon="'far fa-comment-alt-lines portlet-icon'"
            :title="$t('improvements.improvement.chat')"
            :actions-block="true"
            :fullheight="true"
            class="portlet-pt-20"
        >
          <template slot="actionsBlock">
            <!--              <button class=" btn btn-secondary   " @click="filterOpen = !filterOpen">-->
            <!--                <i class="far mr-3"-->
            <!--                   :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"/>-->
            <!--                {{ !filterOpen ? $t('jobs.filter.jobs') : $t('jobs.filter.close') }}-->
            <!--              </button>-->
          </template>
          <template slot="portletBody">
            <Chat :improvement="improvement"></Chat>
          </template>
        </portlet>
      </div>

    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import LikeButton from "@/components/improvements/LikeButton";
import Chat from "@/components/improvements/Chat";
import icons from "@/mixins/improvements/icons";

import 'viewerjs/dist/viewer.css'
import 'viewerjs/dist/viewer.css'
import {component as Viewer} from "v-viewer"

export default {
  name: "Improvement",
  mixins: [icons],
  components: {LikeButton, Chat, Viewer},
  data() {
    return {
      viewerOptions: {
        "inline": false,
        "button": true,
        "navbar": false,
        "title": false,
        "toolbar": true,
        "tooltip": true,
        "movable": true,
        "zoomable": true,
        "rotatable": true,
        "scalable": true,
        "transition": true,
        "fullscreen": true,
        "keyboard": true
      },
      images: [],
      allUsers: [],
      // statusses: ['pending', 'denied', 'plan', 'do', 'check', 'act', 'done',],
      statusses: [
        {value: "pending", visible: false, rights: "admin"},
        {value: "denied", visible: false, rights: "admin"},
        {value: "plan", visible: true, rights: "user"},
        {value: "do", visible: true, rights: "user"},
        {value: "check", visible: true, rights: "user"},
        {value: "act", visible: true, rights: "user"},
        {value: "done", visible: true, rights: "user"},
      ],
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("users", ["getClaims", "getMe"]),
    ...mapGetters("improvements", ["getImprovement"]),

    improvement() {
      return this.getImprovement(this.$route.params.improvementId);
    },
  },
  methods: {
    showModal(index) {
      alert(index)
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
    warningPopUp() {
      return this.$swal({
        icon: "warning",
        title: this.$t("ui.invalidForm"),
        text: this.$t("ui.invalidFormText"),
      });
    },
    saveChanges() {
      this.$validator
          .validateAll()
          .then((result) => {
            if (!result) {
              return this.warningPopUp();
            } else {
              return this.$store
                  .dispatch("improvements/patch", {
                    id: this.improvement.id,
                    title: this.improvement.title,
                    body: this.improvement.body,
                  })
                  .then(() => {
                    this.swalToastSuccess("Status updated");
                  });
            }
          })
          .catch((e) => {
            console.log(e);
          });
    },
    updateStatus() {
      return this.$store
          .dispatch("improvements/patch", {
            id: this.improvement.id,
            status: this.improvement.status,
          })
          .then(() => {
            this.swalToastSuccess("Status updated");
          });
    },
    updateAssignee(event) {
      let user = _.find(this.allUsers, (user) => {
        return user.uid == event.target.value;
      });
      return this.$store
          .dispatch("improvements/patch", {
            id: this.improvement.id,
            assignedUser: (this.improvement.assignedUser = {
              name: user.displayName,
              email: user.email,
              uid: user.uid,
            }),
          })
          .then(() => {
            this.swalToastSuccess("Assignee updated");
          });
    },
  },

  async beforeRouteLeave(to, from, next) {
    // await this.$store.dispatch("improvements/closeDBChannel");
    next();
  },
  watch: {},
  async created() {
    this.$FUNCTIONS
        .Users("getAllUsers")
        .then((res) => {
          this.allUsers = _.sortBy(res.data, ['displayName'], ['desc'])
          this.$store.commit("setLoading", false);
        })
        .catch((e) => {
          this.$store.commit("setLoading", false);
        });

    const me = this.getMe;
    const self = this;
    await this.$store.dispatch(
        "improvements/fetchById",
        this.$route.params.improvementId
    );
    if (!this.improvement.assignedUser) {
      await self.$store.dispatch("improvements/patch", {
        id: self.$route.params.improvementId,
        assignedUser: {},
      });
    }
    try {
      let listReference = this.$FBClient.storage().ref("improvements/" + this.getClaims.companyId + "/" + this.improvement.id)
      let list = await listReference.listAll()

      for (let i = 0; i < list.items.length; i++) {
        let item = list.items[i]
        let fileUrl = await item.getDownloadURL()

        this.images.push(
            {
              imgSrc: fileUrl,
              id: i
            })
        //     .then((imgUrl) => {
        //       console.log('image urk', imgUrl)
        //       this.user.photoURL = imgUrl;
      }


      //     .getDownloadURL()
      //     .then((imgUrl) => {
      //       console.log('image urk', imgUrl)
      //       this.user.photoURL = imgUrl;
      //
      //     }).catch((e) => {
      //
      // })

    } catch (e) {
      console.log(1, e)
    }
    if (me.id === this.improvement.assigneeHasNotSeen) {
      await self.$store.dispatch("improvements/patch", {
        id: self.$route.params.improvementId,
        assigneeHasNotSeen: null,
      });
    }
  },
};
</script>

<style scoped>
.preview-image {
  width: calc(20% - 10px);

  height: auto;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

.image {
  width: calc(20% - 10px);
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}
</style>